module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc32-ec4e43449d89934381621d6b5eca80d5.jpg";